import { MessageCircle } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { normalizePhone, toWhatsAppUrl } from '@physioedge/shared';
import { api } from '../api';

export function useSupportPhone() {
  return useQuery({
    queryKey: ['public-settings'],
    queryFn: () =>
      api.get<{
        supportPhone: string;
        physioedgePolicy: string;
        clinicPolicy: string;
        clinicPartnershipPolicy: string;
        instapayRecipient: string;
        instapayPayUrl: string;
        instapayAccountName: string;
      }>('/api/public/settings'),
    staleTime: 60_000,
  });
}

export function WhatsAppHelp({
  className = '',
  label = 'WhatsApp us',
  compact = false,
}: {
  className?: string;
  label?: string;
  compact?: boolean;
}) {
  const q = useSupportPhone();
  const phone = q.data?.supportPhone ?? '';
  const href = toWhatsAppUrl(phone);
  if (!href) return null;
  const display = normalizePhone(phone);

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={`inline-flex items-center justify-center gap-1.5 text-sm font-medium text-sand-strong hover:underline touch-manipulation ${className}`}
    >
      <MessageCircle className={compact ? 'w-3.5 h-3.5' : 'w-4 h-4'} />
      <span>{label}</span>
      {display ? <span className="tabular-nums font-semibold">{display}</span> : null}
    </a>
  );
}
